import Box from '../../../../../components/Layout/Components/Box/Box';
import BoxHeader from '../../../../../components/Layout/Components/Box/Header/BoxHeader';
import BoxHeaderIcon from '../../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import React from 'react';
import styled from 'styled-components';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';

const Card = styled.div`
  flex: 1;
  padding: 0 20px 30px 20px;
`;
const Body = styled.div`
  padding: 0 20px 10px 20px;
  font-size: 0.8rem;
`;

const InfoTile = ({ children, icon, color, lastUpdate }) => {
  return (
    <Card>
      <Box>
        <BoxHeader>
          <BoxHeaderIcon color={color}>{icon}</BoxHeaderIcon>
          {children}
        </BoxHeader>
        <Body>
          <FormattedMessage id={'stats.updated'} />
          &nbsp;
          {lastUpdate && (
            <>
              <FormattedDate value={lastUpdate} /> <FormattedTime value={lastUpdate} hour="numeric" minute="numeric" second="numeric" />
            </>
          )}
        </Body>
      </Box>
    </Card>
  );
};

export default InfoTile;
